export default "__VITE_ASSET__mMwUmit1__"